<h2 mat-dialog-title>
  {{ 'OMNISEARCH.SWITCH_TO_PARTNER' | translate }}
</h2>
<div class="searchbox">
  <mat-form-field floatLabel="never">
    <input
      matInput
      #searchTerm
      [placeholder]="'OMNISEARCH.SEARCH_BY_PID' | translate"
      (keyup.enter)="switchPartner(searchTerm.value)"
      autocomplete="off"
      />
  </mat-form-field>
</div>
<mat-dialog-content>
  <mat-nav-list>
    @if ((recentPartners$ | async)?.length > 0) {
      <h3 matSubheader>
        {{ 'OMNISEARCH.RECENT' | translate }}
      </h3>
    }
    @for (recentPartner of recentPartners$ | async; track recentPartner) {
      <a
        tabindex="0"
        mat-list-item
        (click)="switchPartner(recentPartner.id)"
        (keyup.enter)="switchPartner(recentPartner.id)"
        >
        <h4 matListItemTitle class="row-title">
          {{ recentPartner.id }}
          @if (recentPartner.subscription_tier_id) {
            <span>({{ recentPartner.subscription_tier_id }})</span>
          }
        </h4>
        <p matListItemLine>
          {{ recentPartner.name }}
          @if (recentPartner.address_line_one) {
            <span>
              - {{ recentPartner.address_line_one }} {{ recentPartner.city }} {{ recentPartner.state_code }}
            </span>
          }
        </p>
      </a>
    }
    @if ((partners$ | async)?.length > 0 && (recentPartners$ | async)?.length > 0) {
      <mat-divider></mat-divider>
    }
    @if ((partners$ | async)?.length > 0) {
      <h3 matSubheader>
        {{ 'OMNISEARCH.SEARCH_RESULTS' | translate }}
      </h3>
    }
    @for (partner of partners$ | async; track partner) {
      <a
        tabindex="0"
        mat-list-item
        (click)="switchPartner(partner.id)"
        (keyup.enter)="switchPartner(partner.id)"
        >
        <h4 matListItemTitle class="row-title">{{ partner.id }} ({{ partner.subscription_tier_id }})</h4>
        <p matListItemLine>
          {{ partner.name }}
          @if (partner.address_line_one) {
            <span>
              - {{ partner.address_line_one }} {{ partner.city }} {{ partner.state_code }}
            </span>
          }
        </p>
      </a>
    }
  </mat-nav-list>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
